import './resellerscreenmenu.styles.scss';
import { useSelector } from 'react-redux';
import { useState, useEffect, useContext } from 'react';
import Sidebar from '../../../components/sidebar/sidebar.component';
import HeaderComponent from '../../../components/header-component/header.component';
import HeadingPrimary from '../../../components/typography/headings/heading-primary/heading-primary.component';
import { SimContext } from '../../../api/SimContext';
// Import screens
import ResellerInventoryScreen from '../resellerinventoryscreen/resellerinventoryscreen.component';
import ResellerSoldSimsScreen from '../resellersimscreen/resellersimscreen.component';
import ResellerProductScreen from '../resellerproductscreen/resellerproductscreen.component';
import ExpiredScreen from '../resellerexpiredcomponent/expired.component';
import ExceptionScreen from '../resellerexceptionscomponent/exceptions.component';
import ResellerReportScreen from '../resellerreportscreen/resellerreportscreen.component';

// Import Selector component
import Selector from '../../../components/selector/Selector.component';

const ResellerScreenMenu = () => {
    const showSidebar = useSelector((state) => state.ui.sidebarOpen);
    const isMobile = window.innerWidth <= 766;
    
    const [showSidebarMobile, setShowSidebarMobile] = useState(false);
    const {simCardStatus} = useContext(SimContext);
    const [inventoryCount, setInventoryCount] = useState('');
    const [soldCount, setSoldCount] = useState('');
    const [expirationCount, setExpirationCount] = useState('');
    const [exceptionCount, setExceptionCount] = useState('');
    const [productCount, setProductCount] = useState(''); 

    const [activeTab, setActiveTab] = useState('Inventory'); // Default active tab
    const [options, setOptions] = useState([
      { label: `Inventory (${inventoryCount})`, value: 'Inventory' },
      { label: `Sold SIMs (${soldCount})`, value: 'Sold Sims' },
      { label: `Expired SIMs (${expirationCount})`, value: 'Expired SIMs' },
      { label: `Exceptions (${exceptionCount})`, value: 'Exceptions' },
      { label: `Products (${productCount})`, value: 'Products' },
      { label: 'Reports', value: 'Reports' }
    ]);

    useEffect(() => {
        // Update options with the latest counts whenever they change
        setOptions([
            { label: `Inventory (${inventoryCount})`, value: 'Inventory' },
            { label: `Sold SIMs (${soldCount})`, value: 'Sold Sims' },
            { label: `Expired SIMs (${expirationCount})`, value: 'Expired SIMs' },
            { label: `Exceptions (${exceptionCount})`, value: 'Exceptions' },
            { label: `Products (${productCount})`, value: 'Products' },
            { label: 'Reports', value: 'Reports' }
        ]);
    }, [inventoryCount, soldCount, expirationCount, exceptionCount, productCount]);

    // Update active tab based on window size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 766 && showSidebarMobile) {
                setShowSidebarMobile(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [showSidebarMobile]);

    return (
        <div className='header-layout'>
            <div className="bottom-nav-container">
                <HeaderComponent showSidebarMobile={showSidebarMobile} setShowSidebarMobile={setShowSidebarMobile} />
            </div>
            <div className='portalscreen-layout'>
                {isMobile ? (
                    <div className={`sidebar-container-mobile ${showSidebarMobile ? 'sidebar-visible' : ''}`}>
                        <div className={`sidebar-container ${showSidebar ? 'expanded' : ''}`}>
                            <Sidebar />
                        </div>
                    </div>
                ) : (
                    <div className={`sidebar-container ${showSidebar ? 'expanded' : ''}`}>
                        <Sidebar />
                    </div>
                )}
                <div className='content-container'>
                    <div className='heading-container'>
                        <HeadingPrimary text={'Reseller Screen'} mode={'dark'} />
                    </div>
                    <div className='tab-menu-container'>
                        {isMobile ? (
                            <Selector
                                options={options}
                                accentColor={'var(--dynamic-color)'}
                                onSelectionChange={handleSelectionChange}
                                defaultValue={options[0].value}
                            />
                        ) : (
                            <div className="tabs-wrapper">
                                {options.map(option => (
                                    <button
                                        key={option.value}
                                        className={`tab ${activeTab === option.value ? 'active' : ''}`}
                                        onClick={() => handleSelectionChange(option.value)}
                                    >
                                        {option.label}
                                    </button>
                                ))}
                            </div>
                        )}
                        <div className="tab-content">
                            {activeTab === 'Inventory' && <ResellerInventoryScreen setInventoryCount={setInventoryCount} />}
                            {activeTab === 'Sold Sims' && <ResellerSoldSimsScreen setSoldCount={setSoldCount} />}
                            {activeTab === 'Products' && <ResellerProductScreen setProductCount={setProductCount} />}
                            {activeTab === 'Expired SIMs' && <ExpiredScreen setExpirationCount={setExpirationCount} />}
                            {activeTab === 'Exceptions' && <ExceptionScreen setExceptionCount={setExceptionCount} />}
                            {activeTab === 'Reports' && <ResellerReportScreen setExceptionCount={setExceptionCount} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    function handleSelectionChange(selectedValue) {
        setActiveTab(selectedValue);
    }
};

export default ResellerScreenMenu;
